import './driver.css'
import React from 'react'
import DashboardTable from '../dashboardtable/dashboardtable';
import data from './data.json'
import search from '../../../../assets/images/search.png'
import add from '../../../../assets/images/add.png'

function Driver() {
    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>Drivers</h3>
                <div>
                    <div className='input-header-admin'>
                        <input
                            type="text"
                            placeholder='Search' />
                        <img src={search} alt="" />
                    </div>
                    <div className='nav-buttons'>
                        <button style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add Driver</button>
                    </div>
                </div>
            </div>
            <div className='dashboard-table-wrapper_'>
                <DashboardTable size={10} columns={columns} rows={data.data} height={"510px"} />
            </div>
        </>
    )
}

const columns = [
    { field: 'fullname', headerName: 'Full Name', minWidth: 60 },
    { field: 'middlename', headerName: 'Middle Name', minWidth: 60 },
    { field: 'lastname', headerName: 'Last Name', minWidth: 60 },
    { field: 'phone', headerName: 'Phone', minWidth: 60 },
    { field: 'email', headerName: 'Email', minWidth: 225 },
    { field: 'truck_no', headerName: 'Truck No.', minWidth: 60 },
    { field: 'trailer_no', headerName: 'Trailer No.', minWidth: 60 },
    { field: 'address', headerName: 'Address', minWidth: 225 }
];

export default Driver